import React, { useEffect } from "react";
import { appInsightsEvents, trackEvent, useAppStore } from "../../../common";
import { useStyles } from "./OrderHistoryListViewStyles";
import { LoadingScreen, NoResultsMessage } from "../../shared";
import { OrderHistoryList } from "../OrderHistoryList";

export const OrderHistoryListView = () => {
  const styles = useStyles();
  const appInsights = useAppStore((state) => state.appInsights);
  const context = useAppStore((state) => state.context);
  const ordersHistory = useAppStore((state) => state.ordersHistory);

  const {
    loading: loadingOrderHistory,
    fetch: fetchOrdersHistory,
    values: orderHistory,
  } = ordersHistory;

  // Initializes the component
  useEffect(() => {
    fetchOrdersHistory();
  }, []);
  useEffect(() => {
    trackEvent(appInsights, appInsightsEvents.Usage.ViewComponent, context, {
      componentName: "OrderHistoryListView",
    });
  }, [context, appInsights]);

  return (
    <div className={styles.container} data-testid="OrderHistoryListView">
      <main className={styles.main}>
        <div className={styles.subMainContainer}>
          {loadingOrderHistory ? (
            <LoadingScreen />
          ) : orderHistory && orderHistory.length > 0 ? (
            <OrderHistoryList ordersHistory={orderHistory} />
          ) : (
            <NoResultsMessage
              primaryMessage="Looks like you haven't placed any orders with us yet."
              secondaryMessage="Once you start ordering, your history will show up here. Check out today's menu to place your first order!"
              isOrderHistoryVisible={true}
            />
          )}
        </div>
      </main>
    </div>
  );
};
